import { Tabs } from "@mantine/core";
import { useState } from "react";
import { useSelector } from "react-redux";
import { PageLayout } from "../../components/layout";
import { ScfFinanceLimitList } from "../../components/limit/scf-list";
import { IAuth } from "../../interfaces/IAuth";

export const LimitUsageList = () => {
  const breadcrumbs = useBreadcrumb();
  const { user } = useSelector((state: { auth: IAuth }) => state.auth);
  const [filters, setFilters] = useState<any>({ financeType: "SCF" });

  return (
    <PageLayout title="Лимит ашиглалт" subTitle="Лимит ашиглалтын жагсаалт" breadcrumb={breadcrumbs}>
      <Tabs
        onTabChange={(e) => {
          setFilters({
            ...filters,
            financeType: e,
          });
        }}
        value={filters.financeType}
        color={"golomt"}>
        <Tabs.List>
          {/* <Tabs.Tab value={"LBF"} py="md">
            Зээлийн шугамаар
          </Tabs.Tab> */}
          <Tabs.Tab value={"SCF"} py="md" disabled={user?.currentBusiness?.type === "BUYER"}>
            Нэхэмжлэх барьцаалах
          </Tabs.Tab>
        </Tabs.List>
        <ScfFinanceLimitList filters={filters} />
      </Tabs>
    </PageLayout>
  );
};

const useBreadcrumb = () => [
  {
    to: "/",
    label: "Үндсэн",
  },
  {
    to: "/",
    label: "Санхүүжилт",
  },
  {
    label: "Лимит ашиглалт",
  },
];
